module.exports = __webpack_public_path__ + "img/avocado_yes.da69459d.png";